module.exports = __webpack_public_path__ + "assets/images/nsng.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/nsng.png
// module id = 254
// module chunks = 1